import ENV from 'nightwatch-web/config/environment';

const isTesting = ENV.environment === 'test';

export default isTesting;
